import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/rtl.css';
import './i18n'; // Initialize i18n before App
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/theme.css';
import './styles/light-controls.css';
import './styles/light-mode.css';
import './styles/light-navigation.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
